<template>
  <div class="select_dialog_embed" id="select_dialog_embed" :style="{'overflow-y' : (isShow ? 'hidden' : 'auto') }">
    <div class="store_link_list_embed_msg"
         :class="{'synchronizationOfInventory' : showType === 'sllSynchronizationOfInventory',
         'w580' : showType === 'batchCloseInventoryObject' || showType === 'batchSynchronousInventory' || showType === 'import',
         'numUpDown' : showType === 'sllNumUpDown'}">
      <div class="select_dialog_embed_box">
        <!--弹出框头部-->
        <div class="select_dialog_embed_box_top">
          <p>{{title}}
            <span v-if="showType === 'sllSetInventoryObject' || showType === 'batchSllSetInventoryObject'" class="fcDel">（配仓优先级不填写默认为0，为0时优先程度最低）</span>
          </p>
        </div>

        <!--弹出框信息-->
        <div class="select_dialog_embed_box_content">
          <!--链接详情-->
          <div v-if="showType === 'sllLinkDetail'" class="select_dialog_embed_box_handle link_detail">
            <table class="table">
              <thead>
              <tr>
                <th>平台属性</th>
                <th>商家编码</th>
                <th>数量</th>
                <th>货号</th>
                <th>属性</th>
                <th>数量</th>
                <th>类型</th>
              </tr>
              </thead>
              <tbody v-if="linkDetail.length">
              <template v-for="item in linkDetail">
                <tr v-for="(itemChild, indexChild) in item.linkskuInfo">
                  <td v-if="indexChild === 0" :rowspan="item.linkskuInfo.length" style="width: 260px; padding: 0;">{{item.OutProp}}</td>
                  <td v-if="indexChild === 0" :rowspan="item.linkskuInfo.length" class="w150"><input type="text" v-model="item.GroupBusinessCode"></td>
                  <td v-if="indexChild === 0" :rowspan="item.linkskuInfo.length">{{item.LinkSkuStock}}</td>
                  <td>{{itemChild.goodsId}}</td>
                  <td>{{itemChild.attribute}}</td>
                  <td>{{itemChild.quantity}}</td>
                  <td>{{itemChild.sType | sellorsend}}</td>
                </tr>
              </template>
              </tbody>
              <tbody v-if="!linkDetail.length">
              <tr>
                <td colspan="7">暂时没有相关信息</td>
              </tr>
              </tbody>
            </table>
          </div>

          <!--设置库存对接-->
          <div v-if="showType === 'sllSetInventoryObject' || showType === 'batchSllSetInventoryObject'" class="select_dialog_embed_box_handle set_inventory_obj">
            <!--列表信息-->
            <div class="inventory_docking_list">
              <table class="table tb_border">
                <colgroup>
                  <col style="width: 100%">
                </colgroup>
                <thead>
                <tr>
                  <th class="bdd-n bdl-l"><input type="checkbox" title="全选" v-model="checkAll" @click="checkOneOrAll()"></th>
                  <th class="bdd-n">渠道名称</th>
                  <th class="bdd-n">配货率</th>
                  <th class="bdd-n">配仓优先级</th>
                </tr>
                </thead>
              </table>
              <table class="table tb_border">
                <colgroup>
                  <col style="width: 100%">
                </colgroup>
                <tbody v-if="inventoryDockingList.length">
                <tr v-for="(item, index) in inventoryDockingList" :key="index">
                  <td class="bdl-l"><input type="checkbox" title="选择渠道" v-model="item.IsHave" @click="checkOne(index)"></td>
                  <td>{{item.StoreroomName}}</td>
                  <td class="bdd-r" v-if="item.RealSendRate || item.RealSendRate === 0">{{item.RealSendRate}}%</td>
                  <td class="bdd-r" v-if="!item.RealSendRate && item.RealSendRate !== 0"></td>
                  <td class="bdd-r"><input type="text" title="配仓优先级" v-model.number="item.SetOrderNum"></td>
                </tr>
                </tbody>
                <tbody v-if="!inventoryDockingList.length">
                <tr>
                  <td colspan="5">暂时没有相关信息</td>
                </tr>
                </tbody>
              </table>
            </div>
            <!--关闭货号库存对接-->
            <div v-if="showType !== 'batchSllSetInventoryObject'" class="close_good_num_inventory">
              <input type="checkbox" id="closeGoodNumInventory" v-model="isCloseNumInventory" title="关闭货号库存对接">
              <label for="closeGoodNumInventory">关闭链接库存对接（关闭后链接将不再同步系统库存）</label>
            </div>
            <!-- <div class="close_good_num_inventory">
               <input type="checkbox" id="closeGoodNumInventory" v-model="isCloseNumInventory" title="店铺成本过滤设置">
               <label for="closeGoodNumInventory">是否使用店铺成本过滤设置</label>
             </div> -->
          </div>

          <!--批量关闭链接库存对接-->
          <div v-if="showType === 'batchCloseInventoryObject'" class="select_dialog_embed_box_handle text_center pt20 pb15">
            是否关闭选择的链接库存对接？
          </div>

          <!--同步库存-->
          <div v-if="showType === 'sllSynchronizationOfInventory'" class="select_dialog_embed_box_handle">
            请确定是否需要同步此链接的库存？同步完成后链接对应的该货品的库存会进行改变！
          </div>

          <!--同步库存-->
          <div v-if="showType === 'batchSynchronousInventory'" class="select_dialog_embed_box_handle">
            请确定是否需要同步选择链接的库存？同步完成后链接对应的该货品的库存会进行改变！
          </div>

          <!--链接上下架-->
          <div v-if="showType === 'sllNumUpDown'" class="select_dialog_embed_box_handle">
            <ul>
              <li class="clear"><input type="radio" value="up" v-model="numUpDownVal" id="up" name="upDown"> <label for="up">上架</label></li>
              <li class="clear"><input type="radio" value="down" v-model="numUpDownVal" id="down" name="upDown"> <label for="down">下架</label></li>
            </ul>
          </div>

          <!--导入猫超商品资料-->
          <div v-if="showType === 'import'" class="select_dialog_embed_box_handle text_center pt20 pb15">
            <div><button class="btn_normal" @click="getMaoChaoLinkImportExcelTemplet">猫超商品资料模板</button> </div>

            <span>选择上传的文件：</span>
            <input id="import_file" type="file" @change="tirggerFile($event)" accept=".xls,.xlsx">
          </div>
        </div>

        <!--弹出框底部-->
        <div class="select_dialog_embed_box_bottom pb30">
          <button v-if="showType !== 'goodDetail' && showType !== 'sllLinkDetail'" class="btn_normal" @click="submitBtn()">确定</button>
          <button v-if="showType === 'sllLinkDetail'" class="btn_normal" @click="submitBtn()">同步商家编码</button>
          <button class="btn_cancel" @click="cancelBtn(false)">关闭</button>
        </div>
      </div>
    </div>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                :contentType="showType"
                @closebtn="closeMsgDialog"></msg-dialog>

    <!--弹出判断框-->
    <baby-dialog v-if="isShow"
                 :title="dialogTitle"
                 :show-type="showType"
                 :upDownValue="isUpDown"
                 :msg="babyDialogMsg"
                 @cancelmsgbtn="getBabyDialog"></baby-dialog>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="loadingType"></loading-dialog>
  </div>
</template>

<script type="es6">
  import MsgDialog from '../../../public-component/msg-dialog';
  import BabyDialog from './baby-dialog';
  import LoadingDialog from '../../../public-component/loading-dialog';

    export default {
      name: 'store-link-list-embed-msg',
      /**
       *  title：  头部名
       *  showType: sllLinkDetail=链接详情信息  sllSetInventoryObject=设置库存对接
       *            sllSynchronizationOfInventory=同步库存  sllNumUpDown=链接上下架
       *  linkMsg: 链接信息
       * */
      props: ['title', 'showType', 'linkMsg', 'shopId'],
      components: {MsgDialog, BabyDialog, LoadingDialog},
      data() {
        return {
          linkDetail: '', // 店铺链接详情
          inventoryDockingList: [], // 设置库存对接的列表
          isCloseNumInventory: false, // 关闭货号库存对接（关闭后对应的链接所属货号的SKU将不再同步系统库存） 1=开启=true，2=关闭=false
          checkAll: false, // 全选
          numUpDownVal: 'up', // 货号上下架值
          importFile: null, // 上传文件
          isUpDown: false, // 是否上下架
          isShow: '', // 是否显示弹出判断框
          babyDialogMsg: null, // 传入判断框里的信息
          dialogTitle: '', // 弹出判断框头部
          isMsg: false, // 信息框显示
          isSuc: false, // 是否成功
          txtMsg: '', // 信息框内容
          isLoading: false, // 是否显示加载框
          loadingType: 'NOP', // 加载页面类型
          time: 3, // 倒计时时间
          timer: null // 计时器
        }
      },
      methods: {
        // 猫超商品资料模板
        getMaoChaoLinkImportExcelTemplet() {
          console.log(999999);
          this.$axios.get(this.Global.getMaoChaoLinkImportExcelTemplet).then((res) => {
            if (!res.data.errorMsg.length) {
              window.open(res.data.resData, '_blank');
            } else {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
            }
          });
        },

        // 获取文件
        tirggerFile(e) {
          this.importFile = e.target.files;
        },

          // 导入猫超商品资料模板
        importMaoChaoLinkExcel() {
          console.log(1112, this.importFile);
          if (!this.importFile) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请选择要导入的文件';
            return;
          }
          this.isLoading = true;
          this.loadingType = 'options';
          const formData = new FormData();
          // const formData = new window.FormData();
          formData.append('body', this.importFile[0]);
          this.$axios.post(this.Global.importMaoChaoLinkExcel, formData).then((res) => {
            document.getElementById('import_file').value="";  // 清空上传的文件：解决—订单导入这个的功能，选择的上传文件如果发生变更，点击开始导入  会没响应，经常会出现导入报错后，用户手动直接重新修改导入文件保存就点击导入没反应。
            let timer;
            const self = this;
            timer = setTimeout(function () {
              self.isLoading = false;
              clearTimeout(timer);
              if (res) {
                 if (!res.data.errorMsg.length && !res.data.resData) {
                // self.cancelBtn(true);
                self.isMsg = true;
                self.isSuc = true;
                self.txtMsg = '导入成功';
              } else if (res.data.resData) {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = '导入失败';
                setTimeout(function () {
                  window.open(res.data.resData);
                }, 500);
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
            }, 500);
          });
        },

        // 查看店铺链接详情
        getShopLinkSkuId() {
          console.log(this.linkMsg);
          this.$axios.post(this.Global.getShopLinkSkuId(this.linkMsg.Id, this.linkMsg.ShopId), null).then((res) => {
            console.log(res);
            if (!res.data.errorMsg.length) {
              this.linkDetail = res.data.resData;
              this.babyDialogMsg = this.linkDetail;
            } else {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
            }
          });
        },

        // 库存对接数据列表
        getStoreroom() {
          this.isLoading = true;
          this.$axios.post(this.Global.getStoreroom(this.linkMsg.NumId, this.shopId), null).then((res) => {
            this.isLoading = false;
            if (!res.data.errorMsg.length) {
              this.inventoryDockingList = res.data.resData.storelist;
              if (res.data.resData.CloseStatus === 1) {
                this.isCloseNumInventory = false;
              } else {
                this.isCloseNumInventory = true;
              }
              // 判断是否全选
              let flag = true;
              this.inventoryDockingList.forEach((value) => {
                if (!value.IsHave) {
                  flag = false;
                  return flag;
                }
              });
              this.checkAll = flag;
            }
          });
        },

        // 获取分销商的渠道信息（ 店铺货品列表、店铺链接列表 批量设置渠道对接适用 ）——获取批量操作的渠道信息入口
        getStoreroomListByShopId() {
          this.$axios.post(this.Global.getStoreroomListByShopId(this.linkMsg.shopId), null).then((res) => {
            if (!res.data.errorMsg.length) {
              this.inventoryDockingList = res.data.resData;
            }
          });
        },

        // 保存链接对接渠道的信息--设置库存对接
        saveStoreroomLinksInfo() {
          this.isLoading = true;
          this.loadingType = 'option';
          let status;
          if (this.isCloseNumInventory) {
            status = 2;
          } else {
            status = 1;
          }
          const params = [];
          for (let i = 0; i < this.inventoryDockingList.length; i++) {
            if (this.inventoryDockingList[i].IsHave) {
              params.push({storeroomId: this.inventoryDockingList[i].StoreroomId, setOrderNum: this.inventoryDockingList[i].SetOrderNum});
            }
          }
          this.$axios.post(this.Global.saveStoreroomLinksInfo(this.linkMsg.NumId, this.shopId, status), params).then((res) => {
            this.isLoading = false;
            let timer;
            const self = this;
            timer = setTimeout(function () {
              clearTimeout(timer);
              self.isShow = false;
              if (res) {
                if (!res.data.errorMsg.length) {
                  self.isMsg = true;
                  self.isSuc = true;
                  self.txtMsg = '操作成功';
                } else {
                  self.isMsg = true;
                  self.isSuc = false;
                  self.txtMsg = res.data.errorMsg;
                }
              }
            }, 500);
          });
        },

        // 批量 保存链接渠道对接的信息
        batchSaveStoreroomLinkDocking() {
          let checkboxModelLst = [];
          for (let i = 0; i < this.inventoryDockingList.length; i++) {
            if (this.inventoryDockingList[i].IsHave) {
              checkboxModelLst.push({storeroomId: this.inventoryDockingList[i].StoreroomId, setOrderNum: this.inventoryDockingList[i].SetOrderNum});
            }
          }
          const params = {
            shopId: this.linkMsg.shopId,
            numIdList: this.linkMsg.checkboxModelLst,
            storeroomOrderNumList: checkboxModelLst
            // storeroomIdList: checkboxModelLst
          };
          this.$axios.post(this.Global.batchSaveStoreroomLinkDocking, params).then((res) => {
            let timer;
            const self = this;
            timer = setTimeout(function () {
              clearTimeout(timer);
              self.isShow = false;
              if (res) {
                if (!res.data.errorMsg.length) {
                  self.isMsg = true;
                  self.isSuc = true;
                  self.txtMsg = '操作成功';
                } else {
                  self.isMsg = true;
                  self.isSuc = false;
                  self.txtMsg = res.data.errorMsg;
                }
              }
            }, 500);
          });
        },

        // 批量 保存链接关闭库存对接信息
        batchCloseLinkStockDocking() {
          const params = {
            shopId: this.linkMsg.shopId,
            numIdList: this.linkMsg.checkboxModelLst,
          };
          this.$axios.post(this.Global.batchCloseLinkStockDocking, params).then((res) => {
            let timer;
            const self = this;
            timer = setTimeout(function () {
              clearTimeout(timer);
              self.isShow = false;
              if (res) {
                if (!res.data.errorMsg.length) {
                  self.isMsg = true;
                  self.isSuc = true;
                  self.txtMsg = '操作成功';
                } else {
                  self.isMsg = true;
                  self.isSuc = false;
                  self.txtMsg = res.data.errorMsg;
                }
              }
            }, 500);
          });
        },

        // 店铺链接的同步库存--单个链接同步库存
        synchLinkStock() {
          this.dialogTitle = '提示';
          this.isShow = true;
          this.$axios.post(this.Global.synchLinkStock(this.shopId, this.linkMsg.NumId), null).then((res) => {
            let timer;
            const self = this;
            timer = setTimeout(function () {
              clearTimeout(timer);
              self.isShow = false;
              if (res) {
                if (!res.data.errorMsg.length) {
                  self.isMsg = true;
                  self.isSuc = true;
                  self.txtMsg = '操作成功';
                  // self.cancelBtn(true); // 成功后关闭页面
                } else {
                  self.isMsg = true;
                  self.isSuc = false;
                  self.txtMsg = res.data.errorMsg;
                }
              }
            }, 500);
          });
        },

        // 批量 同步多个链接库存
        batchSynchLinkStock() {
          const params = {
            shopId: this.linkMsg.shopId,
            numIdList: this.linkMsg.checkboxModelLst,
          };
          this.$axios.post(this.Global.batchSynchLinkStock, params).then((res) => {
            let timer;
            const self = this;
            timer = setTimeout(function () {
              clearTimeout(timer);
              self.isShow = false;
              if (res) {
                if (!res.data.errorMsg.length) {
                  self.isMsg = true;
                  self.isSuc = true;
                  self.txtMsg = '操作成功';
                  // self.cancelBtn(true); // 成功后关闭页面
                } else {
                  self.isMsg = true;
                  self.isSuc = false;
                  self.txtMsg = res.data.errorMsg;
                }
              }
            }, 500);
          });
        },

        // 店铺链接的链接上下架
        getGoodsOnDrwn() {
          let type;
          if (this.numUpDownVal === 'up') {
            type = 1;
          } else {
            type = 2;
          }
          this.$axios.post(this.Global.getGoodsOnDrwn(this.shopId, this.linkMsg.NumId, type), null).then((res) => {
            let timer;
            const self = this;
            timer = setTimeout(function () {
              clearTimeout(timer);
              self.isShow = false;
              if (res) {
                if (!res.data.errorMsg.length) {
                  self.cancelBtn(true); // 成功后关闭页面
                  self.isMsg = true;
                  self.isSuc = true;
                  self.txtMsg = '操作成功';
                } else {
                  self.isMsg = true;
                  self.isSuc = false;
                  self.txtMsg = res.data.errorMsg;
                }
              }
            }, 500);
          });
        },

        // 单选/全选
        checkOneOrAll() {
          for (let i = 0; i < this.inventoryDockingList.length; i++) {
            this.inventoryDockingList[i].IsHave = !this.checkAll;
          }
        },

        // 单选判断是否全选
        checkOne(i) {
          let flag = true;
          this.inventoryDockingList[i].IsHave = !this.inventoryDockingList[i].IsHave;
          this.inventoryDockingList.forEach((value) => {
            console.log(value);
            if (!value.IsHave) {
              flag = false;
              return flag;
            }
          });
          this.checkAll = flag;
        },

        // 提交按钮
        submitBtn() {
          if (this.showType === 'sllLinkDetail') { // 链接详情信息
            this.dialogTitle = '提示';
            this.isShow = true;
          } else if (this.showType === 'sllSetInventoryObject') { // 保存链接对接渠道的信息--设置库存对接
            this.dialogTitle = '提示';
            this.isShow = true;
          } else if (this.showType === 'batchSllSetInventoryObject') { // 批量 保存链接渠道对接的信息
            this.batchSaveStoreroomLinkDocking();
          } else if (this.showType === 'batchCloseInventoryObject') { // 批量 保存链接关闭库存对接信息
            this.batchCloseLinkStockDocking();
          } else if (this.showType === 'sllSynchronizationOfInventory') { // 同步库存
            this.synchLinkStock();
          } else if (this.showType === 'batchSynchronousInventory') { // 批量同步库存
            this.batchSynchLinkStock();
          } else if (this.showType === 'sllNumUpDown') {
            if (this.numUpDownVal === 'up') {
              this.isUpDown = '上架';
            } else {
              this.isUpDown = '下架';
            }
            this.dialogTitle = '提示';
            this.isShow = true;
          } else if (this.showType === 'import') {
            this.importMaoChaoLinkExcel();
          }

          // 计时器
          // if (this.isMsg) {
          //   this.time = 3;
          //   const self = this;
          //   this.timer = setInterval(function () {
          //     self.time = --self.time;
          //     if (self.time < 1) {
          //       self.isMsg = false;
          //       clearInterval(self.timer);
          //     }
          //   }, 1000);
          // }
        },

        // 取消按钮
        cancelBtn(type) {
          this.isMsg = false;
          this.$emit('cancelbtn', {isShow: false, showType: this.showType, handleType: type});
        },

        // 获取弹出判断框方法返回参数 -- 嵌入弹出框
        getBabyDialog(e) {
          this.isShow = e.showType;
          if (this.showType === 'sllSetInventoryObject' && e.handleType) {
            this.saveStoreroomLinksInfo();
          } else if (this.showType === 'sllNumUpDown' && e.handleType) {
            this.getGoodsOnDrwn();
            // this.cancelBtn(true);
          } else if (e.handleType) {
            this.cancelBtn(true);
          }
        },

        // 接收提示框传送的数据
        closeMsgDialog(e) {
          this.isMsg = e;
          if (this.isSuc) {
            switch (this.showType) {
              case 'sllSetInventoryObject':
              case 'sllSynchronizationOfInventory':
              case 'batchSllSetInventoryObject':
              case 'batchCloseInventoryObject':
              case 'batchSynchronousInventory':
              case 'import':
                this.isShow = false;
                this.cancelBtn(true); // 成功后关闭页面
                break;
            }
          }
        }
      },
      created() {
        this.babyDialogMsg = this.linkMsg;
        if (this.showType === 'sllLinkDetail') {
          this.getShopLinkSkuId();
        } else if (this.showType === 'sllSetInventoryObject') {
          this.getStoreroom();
        } else if (this.showType === 'batchSllSetInventoryObject') {
          this.getStoreroomListByShopId();
        }
      }
    }
</script>

<style lang="scss" scoped>
  @import "../../../../assets/css/home-view";

  .select_dialog_embed {
    .store_link_list_embed_msg {
      width: 90%;
      min-width: 580px;
      max-height: 100%;

      &.w580 {
        width: 580px;
      }

      .select_dialog_embed_box {
        width: 100%;

        .select_dialog_embed_box_handle {
          width: 100%;
          margin-top: 10px;

          /* 链接详情 start */
          &.link_detail {
            height: 520px;
            overflow-y: auto;

           /* &::-webkit-scrollbar {
              display: none;
            } */

            table {
              width: 98%;
              margin: 0 auto;

              th, td {
                border: 1px solid $bgC;
              }
            }
          }
          /* 链接详情 end */

          /* 设置库存对象 start */
          &.set_inventory_obj {
            /* height: 520px;
            overflow-y: auto; */

            .inventory_docking_list {
              input[type='checkbox'] {
                width: 20px;
              }

              .table {
                width: 90%;
                margin: 0 auto;

                thead, tbody tr {
                  display: table;
                  width: 100%;
                  table-layout: fixed;
                }

                th, td {
                  padding: 10px 0;

                  &:first-child {
                    width: 80px;
                  }
                }

                tbody {
                  display: block;
                  /*width: 100%;*/
                  max-height: 400px;
                  /*overflow-y: auto;*/
                  overflow-y: scroll;
                  width: calc(100% + 1.25em);

                  input[type='text'] {
                    width: 75px;
                  }
                }
              }
            }

            .close_good_num_inventory {
              width: 90%;
              margin: 0 auto;

              input[type='checkbox'] {
                width: 20px;
              }

              label {
                width: calc(100% - 50px);
                text-align: left;
              }
            }
          }
          /* 设置库存对象 end */
        }
      }
    }

    /* 同步库存 start */
    .synchronizationOfInventory {
      width: 62%;
      .select_dialog_embed_box_content {
        .select_dialog_embed_box_handle {
          text-align: center;
          margin-top: 30px;
          margin-bottom: 30px;
        }
      }
    }
    /* 同步库存 end */

    /* 货号上下架 start */
    .numUpDown {
      width: 490px;
      min-width: 490px;

      .select_dialog_embed_box_content {
        .select_dialog_embed_box_handle {
          text-align: center;
          margin-top: 50px;
          margin-bottom: 50px;
          width: 40%;
          height: 40px;

          ul {
            li {
              display: inline-block;
              float: left;

              &:first-child {
                margin-right: 80px;
              }

              input[type='radio']:hover {
                cursor: pointer;
              }
            }
          }
        }
      }
    }
    /* 货号上下架 end */
  }
</style>



// WEBPACK FOOTER //
// src/components/home/goods-management/baby-management/store-link-list-embed-msg.vue